

(function(window, jQuery) {
  var $window = jQuery(window);

  var BackgroundImage = function(element) {
    this.element = element;

    this.onImageLoad = this.onImageLoad.bind(this);
  };
  BackgroundImage.prototype.initialise = function() {
    this.image = this.element.find('[data-sbmb-image]');

    this.currentUrl = undefined;

    if (this.image.length) {
      this.imageUrl = this.image.data('sbmb-image');

      this.load();
    }
  };
  BackgroundImage.prototype.load = function() {
    var image = this.imageUrl;

    this.currentUrl = image;

    var preloadImage = new Image();
    preloadImage.onload = this.onImageLoad;
    preloadImage.src = image;
  };
  BackgroundImage.prototype.onImageLoad = function() {
    this.image.css({
      'background-image': 'url("' + this.currentUrl + '")'
    });

    this.element.addClass('is-loaded');
  };


  var BackgroundImageLoader = function(jQuery) {
    this.jQuery = jQuery;

    this.elementSelector = '[data-sbm-background]';
  };
  BackgroundImageLoader.prototype.setup = function(element) {
    var items = element.find(this.elementSelector);

    if (items.length) {
      for (var i = 0; i < items.length; i++) {
        var item = this.jQuery(items[i]);

        var block = new BackgroundImage(item);
        block.initialise();
      }
    }
  };


  window.SBM = window.SBM || {};
  window.SBM.backgroundImageLoader = new BackgroundImageLoader(jQuery);

  $window.on('load', function() {
    var topLevelElement = jQuery(window.document);

    window.SBM.backgroundImageLoader.setup(topLevelElement);
  });
})(window, jQuery);

